import app from '~/plugins/vue-instance'
import $ from 'jquery'
import _ from 'lodash'
import { globalLogger } from '~/plugins/logger'
import { nextTick } from 'vue'

const focusNextElement = (sender, tabindex, direction) => {
	if ($(sender).parents('[tabscope]').length === 0) {
		globalLogger.error('Tabscope not found. Tabindex broke.')
		return
	}

	var host = _.head($(sender).parents('[tabscope]:not([disabled])'))
	if (!host) {
		return
	}

	let $host = $(host)

	var els = Array.from($host.find(`[tabindex]:visible:not([disabled])`))
	els = els.filter(item => $(item).parents('[disabled]').length === 0)
	els = els.filter(item => parseInt(item.attributes.tabindex.value, 10) > 0)
	els = els.filter(item => _.head($(item).parents('[tabscope]')) === host)

	do {
		var FindNext = (ti) => {
			var arr = []
			for (var i = 0; i < els.length; i++) {
				var x = els[i]
				if (parseInt(x.attributes.tabindex.value, 10) === ti) {
					arr.push(x)
				}
			}
			return arr
		}
		var MinTabIndex = () => {
			if (els.length === 0) {
				return 0
			}

			let min = els.reduce((min, current) => {
				let m = min.attributes ? parseInt(min.attributes.tabindex.value, 10) : min
				let v = parseInt(current.attributes.tabindex.value, 10)

				// we exclude element with tabindex<=0
				if (m <= 0) return v
				if (v <= 0) return m

				let r = m < v ? m : v
				return r > 0 ? r : current
			})

			return _.isNumber(min) ? min : 0
		}
		var MaxTabIndex = () => {
			if (els.length === 0) {
				return 0
			}

			let max = els.reduce((max, current) => {
				let m = max.attributes ? parseInt(max.attributes.tabindex.value, 10) : max
				let v = parseInt(current.attributes.tabindex.value, 10)

				// we exclude element with tabindex<=0
				if (m <= 0) return v
				if (v <= 0) return m

				let r = m > v ? m : v
				return r > 0 ? r : current
			})

			return _.isNumber(max) ? max : 0
		}

		if (tabindex === 0) {
			tabindex = direction === 'down' ? MinTabIndex() : MaxTabIndex()
		}

		var next = FindNext(tabindex)
		if (next.length === 0) {
			let minTabindex = MinTabIndex()
			let maxTabindex = MaxTabIndex()

			if (direction === 'down') {
				while (++tabindex <= maxTabindex) {
					next = FindNext(tabindex)
					if (next.length > 0) {
						break
					}
				}

				if (next.length === 0) {
					next = FindNext(minTabindex)
				}
			} else if (direction === 'up') {
				while (--tabindex > minTabindex) {
					next = FindNext(tabindex)
					if (next.length > 0) {
						break
					}
				}

				if (next.length === 0) {
					next = FindNext(maxTabindex)
				}
			}
		}

		if (next.length === 0) {
			break
		}

		var found = false

		for (var i = 0; i < next.length; i++) {
			var $el = $(next[i])
			var otherHost = $el.parents('[tabscope]').first()
			if (otherHost[0] !== host) {
				var index = els.indexOf($el)
				els.splice(index, 1)
			} else {
				var $parentTabIndex = $el.parents('[tabindex]')
				if ($parentTabIndex.length > 0) {
					$parentTabIndex = $parentTabIndex.first()
					let tabIndexValue = $parentTabIndex.attr('tabindex')
					if ($parentTabIndex.index(host) === -1 && $parentTabIndex.find('[tabscope]').index(host) === -1 && tabIndexValue && tabIndexValue !== '0') {
						console.groupCollapsed('TabIndex')
						console.warn('An element with tabindex attribute needs an immediate tabscope')
						console.log('Parent TabIndex:')
						console.log($parentTabIndex)
						console.log('Child TabIndex:')
						console.log($el)
						console.groupEnd()
					}
				}

				$el.focus()
				found = true
				break
			}
		}
	} while (!found)

	return found
}
const Next = (sender, e) => {
	if ($(sender).parents('[ag-grid]').length || $(sender).find('[ag-grid]').length) return true
	if (sender.getAttribute('is-open')) return true

	e.preventDefault()
	var tabindex = $(sender).attr('tabindex')
	if (typeof tabindex !== 'undefined' && !isNaN(tabindex)) {
		tabindex = parseInt(tabindex, 10)
		if (tabindex === 0) {
			return
		}

		tabindex += 1
		return focusNextElement(sender, tabindex, 'down')
	}
}
const Previous = (sender, e) => {
	if ($(sender).parents('[ag-grid]').length) return true

	e.preventDefault()

	var tabindex = $(sender).attr('tabindex')
	if (typeof tabindex !== 'undefined' && !isNaN(tabindex)) {
		tabindex = parseInt(tabindex, 10)
		if (tabindex === 0) {
			return
		}

		tabindex -= 1
		return focusNextElement(sender, tabindex, 'up')
	}
}

class TabOrderFunctions {

	updateDisabledsScheduled = false

	subscribeKeys(keyPrepend, _vm) {
		var tabindexes = $(_vm.$el).find('[tabindex]')
		var tabscopes = $(_vm.$el).find('[tabscope]')
		app.$keyHandler.Subscribe({
			name: keyPrepend + '-taborder-next',
			keyCode: [9, 13, 40], // 9:tab 13:enter 40:arrow-down
			ctrlKey: false,
			el: tabindexes,
			context: this,
			handler: Next
		}) // taborder-next

		app.$keyHandler.Subscribe({
			name: keyPrepend + '-taborder-previous',
			keyCode: 38, // 38:arrow-up
			ctrlKey: false,
			el: tabindexes,
			context: this,
			handler: Previous
		}) // taborder-previous

		app.$keyHandler.Subscribe({
			name: keyPrepend + '-taborder-previous-shift',
			keyCode: 9, // 9:tab
			shiftKey: true,
			el: tabindexes,
			context: this,
			handler: Previous
		}) // taborder-previous-shift

		app.$keyHandler.Subscribe({
			name: keyPrepend + '-taborder-ctrl-enter-tabscope',
			keyCode: [9, 13], // 9:tab 13:enter
			ctrlKey: true,
			el: tabscopes,
			context: this,
			handler: function (sender, e) {
				e.preventDefault()

				var $scope = $(sender)
				var tabItems = $scope.find('[tabindex]:visible')

				tabItems = tabItems.map(function (index, item) {
					var val = item.attributes.tabindex.value
					if (typeof val === 'undefined' || val === '') {
						val = '0'
					}

					return {
						tabindex: parseInt(val, 10),
						el: item
					}
				})

				tabItems = tabItems.filter((i, x) => x.tabindex > 0)

				if (tabItems.length > 0) {
					var min = tabItems[0]

					for (var i = 1; i < tabItems.length; i++) {
						if (tabItems[i].tabindex < min.tabindex) {
							min.el = tabItems[i].el
						}
					}

					if (min.el != null) {
						$(min.el).focus()
						return true
					}
				}
			}
		}) // taborder-ctrl-enter-tabscope

		app.$keyHandler.Subscribe({
			name: keyPrepend + '-taborder-ctrl-exit-tabindex',
			keyCode: 13, // 13:enter
			ctrlKey: true,
			shiftKey: true,
			el: tabindexes,
			context: this,
			handler: function (sender, e) {
				e.preventDefault()

				var $scope = $(sender).parents('[tabscope]')

				if ($scope.length > 0) {
					$scope[0].focus()
					return true
				}
			}
		}) // taborder-ctrl-exit-tabindex
	}

	updateDisableds() {
		if (this.updateDisabledsScheduled) return
		this.updateDisabledsScheduled = true

		nextTick(() => {
			this.updateDisabledsScheduled = false

			const cssClass = 'auto-disabled'
			const attrName = 'disabled'
			$(`.${cssClass}`).removeAttr(attrName).removeClass(cssClass)

			var disableds = $(`[${attrName}]`)
			var inputs = disableds.find(`input:not([${attrName}]), textarea:not([${attrName}]), button:not([${attrName}])`)

			inputs.each(function (index, el) {
				if ($(el).parents('.nk-dialog').length === 0) {
					$(el).attr(attrName, attrName).addClass(cssClass)
				}
			})
		})
	}
}

const TabOrder = new TabOrderFunctions()
export default TabOrder

export { Next }
